export enum RelationshipStatus {
  Single = 1,
  CommonLaw = 2,
  Married = 3,
  Widowed = 4,
  Separated = 5,
  Divorced = 6
}
